var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"block":"","outlined":"","color":"primary","to":{ name: 'logout' }}},[_vm._v(_vm._s(_vm.$t('common.logout')))])}
var staticRenderFns = []

export { render, staticRenderFns }